"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeModal = void 0;
const react_1 = __importStar(require("react"));
const crate_1 = require("@tcc/crate");
const typography_css_1 = __importDefault(require("@tcc/crate/src/StyleGuide/Typography/typography.css"));
const analytics = __importStar(require("@tcc/analytics"));
const i18n_1 = require("@tcc/i18n");
const upgradeModal_css_1 = __importDefault(require("./upgradeModal.css"));
const UpgradeModalItem_1 = require("../../components/UpdradeModalItem/UpgradeModalItem");
const linksUtils_1 = require("../../utils/linksUtils");
const UpgradeModal = ({ children, className, description, show, title, onClose, items = [], size = 'M', countryCode = 'US', testId = '', targetTier = '', appName = '', featureName = '', }) => {
    const onUpgradeHandler = (0, react_1.useCallback)(() => {
        const upgradeLink = (0, linksUtils_1.getUpgradeLink)(countryCode);
        const eventDetails = {
            targetTier,
            countryCode,
            appName,
            featureName,
        };
        analytics.trackCustomHeapEvent('Product Packaging Upgrade Click', eventDetails);
        window.location.replace(upgradeLink);
    }, [countryCode, targetTier, appName, featureName]);
    const onLearnMoreHandler = (0, react_1.useCallback)(() => {
        window.open((0, linksUtils_1.getPricingInformationLink)(), '_blank');
    }, []);
    if (!show) {
        return null;
    }
    const hasItems = Boolean(items.length);
    const classNames = `${upgradeModal_css_1.default.modalContainer} ${className}`;
    const getTestId = (id) => `${id}${testId ? `-${testId}` : ''}`;
    return (react_1.default.createElement(crate_1.Modal, { className: classNames, size: size, show: true, onClose: onClose, testId: getTestId('product-packaging-upgrade-modal') },
        react_1.default.createElement("div", { className: upgradeModal_css_1.default.titleContainer },
            title && (react_1.default.createElement("div", { "data-test-id": getTestId('product-packaging-upgrade-modal-title'), className: typography_css_1.default.cardTitle }, title)),
            react_1.default.createElement(crate_1.Icon, { className: upgradeModal_css_1.default.closeIcon, glyph: crate_1.Icon.set.REMOVE, onClick: onClose, testId: getTestId('product-packaging-upgrade-modal-close-icon') })),
        react_1.default.createElement("div", { className: upgradeModal_css_1.default.modalContent },
            description && (react_1.default.createElement("div", { "data-test-id": getTestId('product-packaging-upgrade-modal-description'), className: upgradeModal_css_1.default.descriptionContainer }, description)),
            hasItems &&
                items.map((item, i) => (
                // eslint-disable-next-line react/no-array-index-key
                react_1.default.createElement(UpgradeModalItem_1.UpgradeModalItem, { item: item, key: i }))),
            children),
        react_1.default.createElement("div", { className: upgradeModal_css_1.default.actionsContainer },
            react_1.default.createElement(crate_1.Button, { mode: "link", "data-test-id": getTestId('product-packaging-upgrade-modal-learn-more'), onClick: onLearnMoreHandler }, (0, i18n_1.getMessage)('learn.more')),
            react_1.default.createElement(crate_1.Button, { mode: "primary", "data-test-id": getTestId('product-packaging-upgrade-modal-upgrade-button'), onClick: onUpgradeHandler },
                (0, i18n_1.getMessage)('upgrade'),
                targetTier ? `${(0, i18n_1.getMessage)('upgrade.to')} ${targetTier}` : null))));
};
exports.UpgradeModal = UpgradeModal;
